import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { SingleStreamOutputTransformation } from './single-output-stream.transformation';
import { DataFlowDatasetSettings } from './dataset-settings/dataflow-dataset-settings';
import { LinkedService } from '../linkedservice/linkedservice';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';

@Metamodel.model({
    name: 'browse',
    display: [stringResources.DataFlowBrowseTransformationLabel, stringResources.DataFlowBrowseTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class BrowseTransformation extends SingleStreamOutputTransformation {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
    })
    public corpusStore: string;

    @Metamodel.attribute({
    })
    public browseDepth: number = 100;

    public datasetSettings: DataFlowDatasetSettings;

    public schemaLinkedService: LinkedService;

    public parameterBrowse: boolean;

    // for Dynamics
    public browseEntity: boolean;

    // for dynamic generated connector
    public propertyMap: Map<string, DataFlowExpression> = new Map<string, DataFlowExpression>();

    public constructor() {
        super();
    }

    protected getGeneratedDescription(): string {
        // TODO: implement generated description
        return '';
    }
}
